import { transformBlockquotes } from './blockquote';
import { preprocessMentions } from './mentions';

type TextProcessor = (text: string) => string;

const textProcessors: TextProcessor[] = [preprocessMentions, transformBlockquotes];

export function preprocessText(text: string): string {
    return textProcessors.reduce((acc, processor) => processor(acc), text);
}
